import { render, staticRenderFns } from "./FirstStep.vue?vue&type=template&id=128b2f3f&scoped=true&"
import script from "./FirstStep.vue?vue&type=script&lang=ts&"
export * from "./FirstStep.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128b2f3f",
  null
  
)

export default component.exports